var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-wrapper"},[_c('div',{class:['indicator', { 'offset-right': _vm.currentResidenceIndex === 1 }]}),_c('div',{class:['toggle-option', { selected: _vm.currentResidenceIndex === 0 }],on:{"click":() => _vm.setCurrentResidence({ index: 0 })}},[_vm._v(" "+_vm._s(_vm.truncateAddress(_vm.residence1))+" ")]),_c('div',{class:[
      'darker',
      'toggle-option',
      { selected: _vm.currentResidenceIndex === 1 }
    ],on:{"click":() => _vm.setCurrentResidence({ index: 1 })}},[_vm._v(" "+_vm._s(_vm.truncateAddress(_vm.residence2))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }